import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiNotify extends Layout {
    panelEdiNotify: Panel;
    sourceEdiNotify: DataSource;
    tableEdiNotifyInbound: Table;
    tableEdiNotifyOutbound: Table;
}
